<div class="logo-image">
    <img src="/assets/img/logo.png">
</div>
